export const TEST = 'TEST'

// WhiteBoard related action types
export const SET_BRUSH_COLOR = 'SET_BRUSH_COLOR'
export const SET_BRUSH_RADIUS = 'SET_BRUSH_RADIUS'
export const SET_CANVAS_HEIGHT = 'SET_CANVAS_HEIGHT'
export const SET_CANVAS_WIDTH = 'SET_CANVAS_WIDTH'
export const SET_TOTAL_PAGE = 'SET_TOTAL_PAGE'
export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SET_CANVAS_DATA = 'SET_CANVAS_DATA'


// Authentication related action types
export const SIGN_IN = 'SIGN_IN'
export const SIGN_OUT = 'SIGN_OUT'
export const OPEN_AUTH_MODAL = 'OPEN_AUTH_MODAL'
export const CLOSE_AUTH_MODAL = 'CLOSE_AUTH_MODAL'
export const GET_INITIAL_DATA_FROM_LOCALSTORAGE = 'GET_INITIAL_DATA_FROM_LOCALSTORAGE'



// Classroom

export const FETCH_CLASSROOM_LIST = 'FETCH_CLASSROOM_LIST'
export const SAVE_CLASSROOM_LIST_TO_STORE = 'SAVE_CLASSROOM_LIST_TO_STORE'
export const LOADING_CLASS_ROOM_LIST = 'LOADING_CLASS_ROOM_LIST'
export const SAVE_TODAYS_CLASSROOM_TO_STORE = 'SAVE_TODAYS_CLASSROOM_TO_STORE'
export const LOADING_TODAYS_CLASSROOM = 'LOADING_TODAYS_CLASSROOM'



